import { StockDocumentDefinition, StockDocumentDefinitionListing } from "../models"

export const ACTION_TYPES = {
    FETCH : "FETCH_STOCK_DOCUMENT_DEFINITION" as const,
    FETCH_SUCCESS: "FETCH_DOCUMENT_DEFINITION_SUCCESS" as const,
    FETCH_LISTING : "FETCH_STOCK_DOCUMENT_DEFINITION_LISTING" as const,
    FETCH_LISTING_SUCCESS: "FETCH_DOCUMENT_DEFINITION_LISTING_SUCCESS" as const,
    UPDATE: "UPDATE_DOCUMENT_DEFINITION" as const,
    PATCH: "PATCH_DOCUMENT_DEFINITION" as const,
    SET_FROM_LISTING: "SET_FROM_LISTING" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.FETCH_LISTING, payload: string }
    | { type: typeof ACTION_TYPES.FETCH_LISTING_SUCCESS, payload: StockDocumentDefinitionListing }
    | { type: typeof ACTION_TYPES.SET_FROM_LISTING, payload: string }
    | { type: typeof ACTION_TYPES.FETCH_SUCCESS, payload: StockDocumentDefinition }



// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/actions/types.ts